import { INewDocumentRequest } from "./INewDocumentRequest";

export interface INewDocumentAlternativeRequest extends INewDocumentRequest {
  url: string;
}

export function instanceOfINewDocumentAlternativeRequest(instance: any): instance is INewDocumentAlternativeRequest {
  return instance
    && (instance.url !== undefined);
}
